import React, { useState, useEffect, useContext } from 'react'
import { Formik, Form } from 'formik'
import { FiPlus } from 'react-icons/fi'

import { Button, Textarea, Textbox } from '../Form'

import { api, authHeaders } from '../../services/api'

import { Container } from './styles'
import { toast } from 'react-toastify'
import { GlobalContext } from '../../contexts/GlobalContext'
import Yup from '../../services/yup'
import masks from '../../util/masks'

const baseInitialValues = {
    local: '',
    funcao: '',
    atividades: '',
    inicio: null,
    fim: null
}

const validation = Yup.object({
    local: Yup.string().required('Informe o local.'),
    funcao: Yup.string().required('Informe a função.'),
    atividades: Yup.string().required('Descrevas as atividades desempenhadas.'),
    inicio: Yup.string().date().required('Forneça a data de início.').nullable(),
    fim: Yup.string().date().nullable()
})

export default function ({
    reload, style, experienciaInitialValues, editId, pessoa, ...rest
}) {
    const { checkException } = useContext(GlobalContext)

    const [initialValues, setInitialValues] = useState(baseInitialValues)

    useEffect(() => {
        setInitialValues(experienciaInitialValues || baseInitialValues)
    }, [initialValues])

    async function adicionar(values, { setSubmitting, resetForm }) {
        try {
            await api.post('pessoa_experiencia', values, authHeaders())

            reload()

            setSubmitting(false)
            resetForm()

            toast.success('A experiência foi cadastrada.')
        } catch (e) {
            checkException(e)
        }
    }

    async function editar(values, { setSubmitting, resetForm }) {
        try {
            await api.put(`pessoa_experiencia/${editId}`, values, authHeaders())

            reload()

            setSubmitting(false)
            resetForm()

            toast.success('A experiência foi atualizada.')
        } catch (e) {
            checkException(e)
        }
    }

    async function handleSubmit(values, formikBag) {
        if (editId) {
            editar(values, formikBag)
        } else {
            adicionar(values, formikBag)
        }
    }

    return (
        <Container style={style} edit-mode={!!editId} {...rest}>
            <Formik
                onSubmit={handleSubmit}
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validation}
            >
                {() => (
                    <Form className="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        <Textbox
                            name="local"
                            label="Local"
                        />

                        <Textbox
                            name="funcao"
                            label="Função"
                        />

                        <Textbox 
                            name="inicio"
                            label="Início"
                            mask={masks.date}
                        />

                        <Textbox 
                            name="fim"
                            label="Fim"
                            mask={masks.date}
                        />

                        <Textarea
                            name="atividades"
                            label="Atividades"
                            containerClass="md:col-span-2 lg:col-span-3 xl:col-span-4"
                        />

                        <Button
                            className="transparent w-fit justify-self-end md:col-start-2 lg:col-start-3 xl:col-start-4"
                            type="submit"
                        >
                            {editId ? 'Salvar alterações' : 'Adicionar'}
                            <FiPlus size={16} />
                        </Button>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
